<template>
    <div class="container-fluid create-notification-page">
        <div class="columns">
            <div class="column">
                <h1 class="title">{{ translate("notification_center.main_title") }}</h1>
            </div>
        </div>

        <TopBar />

        <div class="columns">
            <StepsMenu />

            <ChooseSourceEventsStep v-if="activeStep === STEP_CHOOSE_SOURCE_EVENTS" />
            <TypeOfNotificationStep v-if="activeStep === STEP_TYPE_OF_NOTIFICATION" />
            <FilterReceiversStep v-if="activeStep === STEP_FILTER_RECEIVERS" />
            <NotificationContentStep v-if="activeStep === STEP_NOTIFICATION_CONTENT" />

            <ReviewReceiversStep v-if="activeStep === STEP_REVIEW_RECEIVERS" />
            <CostCalculationStep v-if="activeStep === COST_CALUCLATION" />
            <ScheduleSendingStep v-if="activeStep === SCHEDULE_SENDING" />
        </div>

        <SummaryModal ref="summaryModal" />
    </div>
</template>

<script>
    import ChooseSourceEventsStep from "./Create/ChooseSourceEventsStep";
    import TypeOfNotificationStep from "./Create/TypeOfNotificationStep";
    import StepsMenu from "./StepsMenu/StepsMenu";
    import { mapState } from "vuex";
    import {
        STEP_CHOOSE_SOURCE_EVENTS,
        STEP_COST_CALCULATION,
        STEP_FILTER_RECEIVERS,
        STEP_NOTIFICATION_CONTENT,
        STEP_REVIEW_RECEIVERS,
        STEP_SCHEDULE_SENDING,
        STEP_TYPE_OF_NOTIFICATION,
    } from "./consts";
    import FilterReceiversStep from "./Create/FilterReceiversStep";
    import NotificationContentStep from "./Create/NotificationContentStep";
    import ReviewReceiversStep from "./Create/ReviewReceiversStep";
    import CostCalculationStep from "./Create/CostCalculationStep";
    import ScheduleSendingStep from "./Create/ScheduleSendingStep";
    import TopBar from "./Create/TopBar";
    import { eventBus, SUMMARY_MODAL_OPEN } from "./eventBus";
    import SummaryModal from "./Create/SummaryModal";
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "create-notification-app",
        components: {
            SummaryModal,
            TopBar,
            ScheduleSendingStep,
            CostCalculationStep,
            ReviewReceiversStep,
            NotificationContentStep,
            FilterReceiversStep,
            StepsMenu,
            TypeOfNotificationStep,
            ChooseSourceEventsStep,
        },
        mixins: [translatorMixin],
        props: ["userCountryCode"],
        computed: {
            ...mapState("main", ["activeStep"]),
        },
        mounted() {
            this.$store.commit("main/setUserCountryCode", this.userCountryCode);

            this.$store.commit("main/loadActiveStepFromStorage");
            this.$store.commit("choosingSourceEvents/loadSelectedEventsFromStorage");
            this.$store.commit("filteringReceivers/loadSelectedCountriesFromStorage");
            this.$store.commit("filteringReceivers/loadPaymentStatusFromStorage");
            this.$store.commit("typeOfNotification/loadTypeOfNotificationFromStorage");
            this.$store.commit("notificationContent/loadMessageFromStorage");
            this.$store.commit("scheduleTime/loadDelayFromStorage");

            eventBus.$on(SUMMARY_MODAL_OPEN, () => {
                this.$refs.summaryModal.open();
            });
        },
        created() {
            this.STEP_CHOOSE_SOURCE_EVENTS = STEP_CHOOSE_SOURCE_EVENTS;
            this.STEP_TYPE_OF_NOTIFICATION = STEP_TYPE_OF_NOTIFICATION;
            this.STEP_FILTER_RECEIVERS = STEP_FILTER_RECEIVERS;
            this.STEP_NOTIFICATION_CONTENT = STEP_NOTIFICATION_CONTENT;
            this.STEP_REVIEW_RECEIVERS = STEP_REVIEW_RECEIVERS;
            this.COST_CALUCLATION = STEP_COST_CALCULATION;
            this.SCHEDULE_SENDING = STEP_SCHEDULE_SENDING;
        },
    };
</script>

<style scoped></style>
